module.exports = __webpack_public_path__ + "img/maintenance_2.10f7e12c.svg";